import './styles/Footer.css'

const Footer = () => {
  return (
    <div className='footer'>
      <p>Footer</p>
    </div>
  )
}

export default Footer
